import classNames from 'classnames'
import { type CSSProperties, type ReactNode } from 'react'
import { ClickAwayListener } from 'shared/ui'
import styles from './styles.module.scss'

type IActionDropdownProps = {
  setOpen: (value: boolean) => void
  children: ReactNode
  width?: CSSProperties['width']
  transform?: CSSProperties['transform']
  className?: string
}

export const FlowActionDropdown = ({
  setOpen,
  children,
  width,
  transform,
  className,
}: IActionDropdownProps) => {
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div
        className={classNames(styles.dropdown, className, 'nodrag nopan nowheel')}
        style={{
          position: 'absolute',
          pointerEvents: 'all',
          transform,
          width,
        }}
      >
        {children}
      </div>
    </ClickAwayListener>
  )
}
